import { LineChart } from "@mui/x-charts";
import { SeriesValueFormatterContext } from "@mui/x-charts/models/seriesType/common";
import { normalSanatizerBRL } from "src/utils/functions";
import { aggregateYearlyData } from "../utils/functions";

function valueFormatter(value: string) {
  let response = Number(value).toFixed(0).replace(".", ",");
  response = response.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");

  if (response.length > 5) {
    response = response.slice(0, -4) + "k";
  }
  return response;
}

export function CompoundInterestGraph({
  results,
  monthlyAcumulatedInterest,
}: {
  results: ResultsType;
  monthlyAcumulatedInterest: number[];
}) {
  const isHighDataVolume = results.monthlyTax.length > 60;
  const displayMonthlyData = !isHighDataVolume;

  const dataAcumulatedInterest = displayMonthlyData
    ? monthlyAcumulatedInterest
    : aggregateYearlyData(results.monthlyResult);

  const dataInvested = displayMonthlyData
    ? results.monthlyInvested.slice(0, -1)
    : aggregateYearlyData(results.monthlyInvested.slice(0, -1));

  const actualNumberInGraph = displayMonthlyData
    ? monthlyAcumulatedInterest
    : aggregateYearlyData(monthlyAcumulatedInterest);

  return (
    <div className="w-full min-w-[300px] min-h-[300px] h-[300px] sm:h-[400px] md:h-[600px] overflow-auto -ml-2 sm:ml-0">
      <LineChart
        colors={["#8d0202", "#000"]}
        grid={{ vertical: false, horizontal: true }}
        yAxis={[
          {
            valueFormatter: (value) => valueFormatter(value),
          },
        ]}
        series={[
          {
            // total em juros
            data: actualNumberInGraph,
            valueFormatter: (
              value: number | null,
              context: SeriesValueFormatterContext
            ) => {
              if (value === null) {
                return "N/A";
              }
              const index = context.dataIndex;
              let correspondingInvested = 0;
              if (displayMonthlyData) {
                correspondingInvested = results.monthlyResult[index] ?? 0;
              } else {
                correspondingInvested = dataAcumulatedInterest[index] ?? 0;
              }
              return (
                "R$ " +
                normalSanatizerBRL(Number(correspondingInvested.toString()))
              );
            },
            label: "Total em juros",
          },
          {
            // valor investido
            data: dataInvested,
            valueFormatter: (value: number | null) => {
              if (value === null) {
                return "N/A";
              }
              return (
                "R$ " + normalSanatizerBRL(Number(value.toFixed(2))).toString()
              );
            },
            label: "Valor Investido",
          },
        ]}
      />
    </div>
  );
}
